module.exports = __webpack_public_path__ + "home-block-4-overlay-wide@2x-2Ga1Gpw.png";